import { MDM_PROPERTIES, MDM_TYPES } from '@/constants/mdm';
import type {
  RecordFieldType,
  RecordOpportunityType,
} from '@/types/individual_record';

const OPPORTUNITY_ID_COLUMNS = new Set(['Id', 'id', 'opportunityid']);

const SALESFORCE_LINE_ITEM_OPPORTUNITY_ID = 'OpportunityId';
const SALESFORCE_LINE_ITEM_PRODUCT_ID = 'Product2Id';

function valueByColumn(fields: RecordFieldType[], column: string) {
  return fields.find((field) => field.column === column)?.value;
}

function valueByColumns(fields: RecordFieldType[], columns: Set<string>) {
  return fields.find((field) => columns.has(field.column))?.value;
}

function valueByMdmProperty(fields: RecordFieldType[], mdmProperty: string) {
  return fields.find((field) => field.mdm_property === mdmProperty)?.value;
}

export function opportunityProductNames(
  opportunity: RecordOpportunityType,
  products: RecordOpportunityType[],
  dealProducts: RecordOpportunityType[],
) {
  const opportunityId = valueByColumns(
    opportunity.fields,
    OPPORTUNITY_ID_COLUMNS,
  );
  if (!opportunityId || !products.length || !dealProducts.length) return [];

  const productIds = new Set(
    dealProducts
      .filter(
        ({ fields }) =>
          valueByColumn(fields, SALESFORCE_LINE_ITEM_OPPORTUNITY_ID) ===
          opportunityId,
      )
      .map(({ fields }) =>
        valueByColumn(fields, SALESFORCE_LINE_ITEM_PRODUCT_ID),
      )
      .filter(Boolean),
  );
  if (!productIds.size) return [];

  return products
    .filter(({ fields }) =>
      productIds.has(
        valueByMdmProperty(fields, MDM_PROPERTIES[MDM_TYPES.PRODUCT].ID),
      ),
    )
    .map(({ fields }) =>
      valueByMdmProperty(fields, MDM_PROPERTIES[MDM_TYPES.PRODUCT].NAME),
    )
    .filter(Boolean)
    .map(String);
}
